define('templates',['vendor/handlebars.runtime'], function(Handlebars) {
  Handlebars = Handlebars["default"];  var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
templates['absences'] = template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <h4 style=\"margin: 10px 0 0\">"
    + this.escapeExpression((helpers.monthFromDate || (depth0 && depth0.monthFromDate) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.month : depth0),{"name":"monthFromDate","hash":{},"data":data}))
    + "</h4>\n    <ul>\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.persons : depth0),{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </ul>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <li style=\"margin: 0 0;\"><b>"
    + this.escapeExpression(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"name","hash":{},"data":data}) : helper)))
    + "</b>:\n\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.absences : depth0),{"name":"each","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n            </li>\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.actual : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (helpers.is || (depth0 && depth0.is) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.from : depth0),(depth0 != null ? depth0.to : depth0),{"name":"is","hash":{},"fn":this.program(9, data, 0),"inverse":this.program(11, data, 0),"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.actual : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.type : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(data && data.last),{"name":"unless","hash":{},"fn":this.program(24, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return "<span style=\"color:"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.homeOffice : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.program(7, data, 0),"data":data})) != null ? stack1 : "")
    + "\">";
},"5":function(depth0,helpers,partials,data) {
    return "blue";
},"7":function(depth0,helpers,partials,data) {
    return "red";
},"9":function(depth0,helpers,partials,data) {
    return "                        "
    + this.escapeExpression((helpers.dayFromDate || (depth0 && depth0.dayFromDate) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.from : depth0),{"name":"dayFromDate","hash":{},"data":data}))
    + ".\n";
},"11":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "                        "
    + alias2((helpers.dayFromDate || (depth0 && depth0.dayFromDate) || alias1).call(depth0,(depth0 != null ? depth0.from : depth0),{"name":"dayFromDate","hash":{},"data":data}))
    + ".–"
    + alias2((helpers.dayFromDate || (depth0 && depth0.dayFromDate) || alias1).call(depth0,(depth0 != null ? depth0.to : depth0),{"name":"dayFromDate","hash":{},"data":data}))
    + ".\n";
},"13":function(depth0,helpers,partials,data) {
    return "</span>";
},"15":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.is || (depth0 && depth0.is) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.type : depth0),"-",{"name":"is","hash":{},"fn":this.program(16, data, 0),"inverse":this.program(18, data, 0),"data":data})) != null ? stack1 : "");
},"16":function(depth0,helpers,partials,data) {
    return "";
},"18":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.is || (depth0 && depth0.is) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.type : depth0),"/",{"name":"is","hash":{},"fn":this.program(16, data, 0),"inverse":this.program(19, data, 0),"data":data})) != null ? stack1 : "");
},"19":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.is || (depth0 && depth0.is) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.type : depth0),"?",{"name":"is","hash":{},"fn":this.program(20, data, 0),"inverse":this.program(22, data, 0),"data":data})) != null ? stack1 : "");
},"20":function(depth0,helpers,partials,data) {
    return "("
    + this.escapeExpression((helpers._ || (depth0 && depth0._) || helpers.helperMissing).call(depth0,"maybe",{"name":"_","hash":{},"data":data}))
    + ")";
},"22":function(depth0,helpers,partials,data) {
    return "("
    + this.escapeExpression((helpers.trim || (depth0 && depth0.trim) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.type : depth0),{"name":"trim","hash":{},"data":data}))
    + ")";
},"24":function(depth0,helpers,partials,data) {
    return ", ";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<h3 style=\"margin-top: 30px\">"
    + this.escapeExpression((helpers._ || (depth0 && depth0._) || helpers.helperMissing).call(depth0,"Planned absences",{"name":"_","hash":{},"data":data}))
    + "</h3>\n\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.months : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n";
},"useData":true});
templates['feedback'] = template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div id=\"sendFeedback\">\n    <a href=\"https://forms.gle/7htkX8FKHAiXJtQk7\" target=\"_blank\">"
    + this.escapeExpression((helpers._ || (depth0 && depth0._) || helpers.helperMissing).call(depth0,"Send Feedback",{"name":"_","hash":{},"data":data}))
    + "</a>\n</div>\n";
},"useData":true});
templates['issue_tree_header'] = template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "<thead>\n    <tr>\n        <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Subject",{"name":"_","hash":{},"data":data}))
    + "</th>\n        <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Status",{"name":"_","hash":{},"data":data}))
    + "</th>\n        <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Assignee",{"name":"_","hash":{},"data":data}))
    + "</th>\n        <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Start date",{"name":"_","hash":{},"data":data}))
    + "</th>\n        <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Due date",{"name":"_","hash":{},"data":data}))
    + "</th>\n        <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Done",{"name":"_","hash":{},"data":data}))
    + "</th>\n        <th></th>\n    </tr>\n</thead>\n";
},"useData":true});
templates['issue_warning_duedate'] = template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "<strong>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Due date is over.",{"name":"_","hash":{},"data":data}))
    + "</strong> "
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"This issue should be done",{"name":"_","hash":{},"data":data}))
    + " "
    + alias2(((helper = (helper = helpers.due_date || (depth0 != null ? depth0.due_date : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"due_date","hash":{},"data":data}) : helper)))
    + ".";
},"useData":true});
templates['issue_warning_duedate_near'] = template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "<strong>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Due date is near.",{"name":"_","hash":{},"data":data}))
    + "</strong> "
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"This issue has to be done",{"name":"_","hash":{},"data":data}))
    + " "
    + alias2(((helper = (helper = helpers.due_date || (depth0 != null ? depth0.due_date : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"due_date","hash":{},"data":data}) : helper)))
    + ".";
},"useData":true});
templates['issues'] = template({"1":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "<form>\n    <table class=\"list issues\">\n        <thead>\n        <tr>\n            <th>#</th>\n            "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.withProject : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n            "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.withAssigned : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n            <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Status",{"name":"_","hash":{},"data":data}))
    + "</th>\n            <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Subject",{"name":"_","hash":{},"data":data}))
    + "</th>\n            <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Updated on",{"name":"_","hash":{},"data":data}))
    + "</th>\n            <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Due date",{"name":"_","hash":{},"data":data}))
    + "</th>\n        </tr>\n        </thead>\n        <tbody>\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.issues : depth0),{"name":"each","hash":{},"fn":this.program(6, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </tbody>\n    </table>\n</form>\n";
},"2":function(depth0,helpers,partials,data) {
    return "<th>"
    + this.escapeExpression((helpers._ || (depth0 && depth0._) || helpers.helperMissing).call(depth0,"Project",{"name":"_","hash":{},"data":data}))
    + "</th>";
},"4":function(depth0,helpers,partials,data) {
    return "<th>"
    + this.escapeExpression((helpers._ || (depth0 && depth0._) || helpers.helperMissing).call(depth0,"Assigned to",{"name":"_","hash":{},"data":data}))
    + "</th>";
},"6":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2=this.lambda, alias3=this.escapeExpression, alias4="function";

  return "            <tr class=\"hascontextmenu issue "
    + ((stack1 = (helpers.isEven || (depth0 && depth0.isEven) || alias1).call(depth0,(data && data.index),{"name":"isEven","hash":{},"fn":this.program(7, data, 0, blockParams, depths),"inverse":this.program(9, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + " priority-"
    + alias3(alias2(((stack1 = (depth0 != null ? depth0.priority : depth0)) != null ? stack1.id : stack1), depth0))
    + "\">\n                <td class=\"id\"><input name=\"ids[]\" type=\"checkbox\" value=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" style=\"display: none\"><a href=\"/issues/"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "</a></td>\n                "
    + ((stack1 = helpers['if'].call(depth0,(depths[1] != null ? depths[1].withProject : depths[1]),{"name":"if","hash":{},"fn":this.program(11, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n                "
    + ((stack1 = helpers['if'].call(depth0,(depths[1] != null ? depths[1].withAssigned : depths[1]),{"name":"if","hash":{},"fn":this.program(13, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n                <td class=\"status\" title=\""
    + alias3(alias2(((stack1 = (depth0 != null ? depth0.status : depth0)) != null ? stack1.name : stack1), depth0))
    + "\">"
    + alias3(alias2(((stack1 = (depth0 != null ? depth0.status : depth0)) != null ? stack1.name : stack1), depth0))
    + "</td>\n                <td class=\"subject\"><a href=\"/issues/"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.subject || (depth0 != null ? depth0.subject : depth0)) != null ? helper : alias1),(typeof helper === alias4 ? helper.call(depth0,{"name":"subject","hash":{},"data":data}) : helper)))
    + "</a></td>\n                <td class=\"updated_on\">"
    + alias3((helpers.redmineTime || (depth0 && depth0.redmineTime) || alias1).call(depth0,(depth0 != null ? depth0.updated_on : depth0),{"name":"redmineTime","hash":{},"data":data}))
    + "</td>\n                <td class=\"due_date\">"
    + alias3(((helper = (helper = helpers.due_date || (depth0 != null ? depth0.due_date : depth0)) != null ? helper : alias1),(typeof helper === alias4 ? helper.call(depth0,{"name":"due_date","hash":{},"data":data}) : helper)))
    + "</td>\n            </tr>\n";
},"7":function(depth0,helpers,partials,data) {
    return "even";
},"9":function(depth0,helpers,partials,data) {
    return "odd";
},"11":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "<td class=\"project\"><a href=\"/projects/"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.project : depth0)) != null ? stack1.id : stack1), depth0))
    + "\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.project : depth0)) != null ? stack1.name : stack1), depth0))
    + "</a></td>";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return "<td class=\"assigned_to\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.assigned_to : depth0)) != null ? stack1.name : stack1), depth0))
    + "</td>";
},"15":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers._ || (depth0 && depth0._) || helpers.helperMissing).call(depth0,"No issues",{"name":"_","hash":{},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = (helpers.isNotEmpty || (depth0 && depth0.isNotEmpty) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.issues : depth0),{"name":"isNotEmpty","hash":{},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.program(15, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
templates['issues_project'] = template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "<div class=\"box issues\" id=\"my-issues\">\n    <h3>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"My issues",{"name":"_","hash":{},"data":data}))
    + " <span class=\"count\"></span></h3>\n    <a href=\"#\" class=\"select-random\" style=\"display: none;\">"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"select random",{"name":"_","hash":{},"data":data}))
    + "</a>\n    <div class=\"content\"></div>\n</div>\n\n<div class=\"box issues\"  id=\"due-date-issues\">\n    <h3>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Overdue issues",{"name":"_","hash":{},"data":data}))
    + "</h3>\n    <div class=\"content\"></div>\n</div>";
},"useData":true});
templates['issues_welcome'] = template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "<div class=\"box issues\" id=\"my-issues\">\n    <h3>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"My issues",{"name":"_","hash":{},"data":data}))
    + " <span class=\"count\"></span></h3>\n    <a href=\"#\" class=\"select-random\" style=\"display: none;\">"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"select random",{"name":"_","hash":{},"data":data}))
    + "</a>\n    <div class=\"content\"></div>\n    <a href=\"/issues?assigned_to_id=me&amp;set_filter=1&amp;sort=priority%3Adesc%2Cupdated_on%3Adesc\">"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"show all",{"name":"_","hash":{},"data":data}))
    + "</a>\n</div>";
},"useData":true});
templates['last_issue'] = template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2=this.escapeExpression, alias3="function";

  return "<h3>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Last viewed issue",{"name":"_","hash":{},"data":data}))
    + "</h3>\n<p><a href=\"/issues/"
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">#"
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + " – "
    + alias2(((helper = (helper = helpers.projectTitle || (depth0 != null ? depth0.projectTitle : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"projectTitle","hash":{},"data":data}) : helper)))
    + ": "
    + alias2(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"title","hash":{},"data":data}) : helper)))
    + "</a></p>";
},"useData":true});
templates['make_money'] = template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div id=\"makeMoney\" style=\"float: right\">\n    <a href=\"/projects/chci-praci/issues/new?issue[priority_id]=5\">"
    + this.escapeExpression((helpers._ || (depth0 && depth0._) || helpers.helperMissing).call(depth0,"I wanna work!",{"name":"_","hash":{},"data":data}))
    + "</a>\n</div>";
},"useData":true});
templates['new_issue_top_menu'] = template({"1":function(depth0,helpers,partials,data) {
    return "            "
    + this.escapeExpression((helpers._ || (depth0 && depth0._) || helpers.helperMissing).call(depth0,"Vytvořit issue",{"name":"_","hash":{},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    return "            "
    + this.escapeExpression((helpers._ || (depth0 && depth0._) || helpers.helperMissing).call(depth0,"Create issue",{"name":"_","hash":{},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<li>\n    <a href=\"/issues/new\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.czech : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "    </a>\n</li>\n";
},"useData":true});
templates['not_available_user'] = template({"1":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers._ || (depth0 && depth0._) || helpers.helperMissing).call(depth0,"Not available %0",(depth0 != null ? depth0.from : depth0),{"name":"_","hash":{},"data":data}));
},"3":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers._ || (depth0 && depth0._) || helpers.helperMissing).call(depth0,"Not available from %0 to %1",(depth0 != null ? depth0.from : depth0),(depth0 != null ? depth0.to : depth0),{"name":"_","hash":{},"data":data}));
},"5":function(depth0,helpers,partials,data) {
    var helper;

  return ": "
    + this.escapeExpression(((helper = (helper = helpers.type || (depth0 != null ? depth0.type : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"type","hash":{},"data":data}) : helper)));
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return " <span class=\"glyphicon glyphicon-warning-sign\" style=\"color: #d9534f;padding-right:3px;\" title=\""
    + ((stack1 = (helpers.is || (depth0 && depth0.is) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.from : depth0),(depth0 != null ? depth0.to : depth0),{"name":"is","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.type : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"></span>";
},"useData":true});
templates['open_timey'] = template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div id=\"enterTimey\" style=\"float: right\">\n    <a href=\"https://timey.proofreason.com\" target=\"_blank\">"
    + this.escapeExpression((helpers._ || (depth0 && depth0._) || helpers.helperMissing).call(depth0,"Open Timey",{"name":"_","hash":{},"data":data}))
    + "</a>\n</div>";
},"useData":true});
templates['open_wiki'] = template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<li>\n    <a href=\"https://wiki.proofreason.com\" target=\"_blank\">"
    + this.escapeExpression((helpers._ || (depth0 && depth0._) || helpers.helperMissing).call(depth0,"P&R Wiki",{"name":"_","hash":{},"data":data}))
    + "</a>\n</li>\n";
},"useData":true});
templates['relations_header'] = template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "<thead>\n<tr>\n    <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Subject",{"name":"_","hash":{},"data":data}))
    + "</th>\n    <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Status",{"name":"_","hash":{},"data":data}))
    + "</th>\n    <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Assignee",{"name":"_","hash":{},"data":data}))
    + "</th>\n    <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Start date",{"name":"_","hash":{},"data":data}))
    + "</th>\n    <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Due date",{"name":"_","hash":{},"data":data}))
    + "</th>\n    <th>"
    + alias2((helpers._ || (depth0 && depth0._) || alias1).call(depth0,"Done",{"name":"_","hash":{},"data":data}))
    + "</th>\n    <th></th>\n</tr>\n</thead>\n";
},"useData":true});
templates['timey_logger'] = template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"timeyLoggerWrapper\">\n    <span class=\"close\"><span class=\"glyphicon glyphicon-remove\"></span></span>\n    <iframe style=\"border:0; width: 100%; height: 220px\" src=\""
    + this.escapeExpression(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"url","hash":{},"data":data}) : helper)))
    + "\"></iframe>\n</div>";
},"useData":true});
return templates;
});
